import { HandoffHubAPI } from '@weave/schema-gen-ts/dist/schemas/insys/onboarding/v1/handoff-hub/handoff_hub.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaHandoffHubV1Service = bindHTTP(HandoffHubAPI);
export const serviceName = 'handoff-hub-v1' as const;
